<template>
  <div v-if="loaded" class="pb1">
    <div class="m3 p3 white-bg center">
      <p v-if="order.value.description && order.value.date" class="h4n bold m0 py2">{{ order.value.description }}, {{ order.value.date }}</p>
      <div v-if="order.value.type === 'ucpa'">
        <p v-if="order.value.customerId" class="h5n m0 py1"><span class="bold">{{ getReferencelabel("CLIENT_REFERENCE") }}</span> {{ order.value.customerId }}</p>
        <p v-if="order.value.bookingNumber" class="h5n m0 py1"><span class="bold">{{ getReferencelabel("BOOKING_NUMBER") }}</span> {{ order.value.bookingNumber }}</p>
      </div>
      <div v-if="order.value.type === 'ucpa' && order.value.solde && order.value.payment_info.pay_remaining_link" :reference="order.value.status === 'Réservation' ? 'SETTLE_BALANCE' : 'BOOK'" class="flex flex-column col-12 items-center p1">
        <Button class="inline-block col-8 md-col-6 lg-col-4 my2 mx1" btn-color="red" :action="goToPaymentSolde.bind(this, order)">></Button>
        <a v-if="order.value.payment_info.bankDetailsLink" class="underline pointer bold bank-details text-center" :href="order.value.payment_info.bankDetailsLink" target="blank">{{ getReferencelabel("CHANGE_BANK_DETAILS") }}</a>
      </div>
      <div v-if="order.value.productUrl" class="py1">
        <a :href="order.value.productUrl" target="_blank" class="h5n blue semi-bold underline">{{ getReferencelabel("SEE_DESTINATION_PAGE") }}</a>
      </div>
    </div>

    <div v-if="order.value.documents && order.value.documents.length" class="m3 p3 white-bg center">
      <Document :order="order.value" />
    </div>

    <div v-if="showPaymentInfo(order)">
      <div class="m3 p2 white-bg center">
        <p class="h3n bold m0 flex " style="justify-content: left;">{{ getReferencelabel('PAYMENT_INFO') }}</p>

        <p v-if="order.value.payment_info.done_payments.length" class="h4n bold m1 flex " style="justify-content: left;">{{ getReferencelabel('COMPLETED_PAYMENTS') }}</p>
        <div v-for="payment in order.value.payment_info.done_payments" :key="payment" class="m2 white-bg center flex">
          <p class="h5n flex col-6 m0" style="justify-content: left;">
            {{ payment.date }}
          </p>
          <p class="h5n flex col-6 m0" style="justify-content: right;">
            {{ payment.amount }} €
          </p>
        </div>

        <p v-if="order.value.payment_info.future_payments.length" class="h4n bold m1 flex " style="justify-content: left;">{{ getReferencelabel('FUTURE_PAYMENTS') }}</p>
        <div v-for="payment in order.value.payment_info.future_payments" :key="payment" class="m2 white-bg center flex">
          <p class="h5n flex col-6 m0" style="justify-content: left;">
            {{ payment.date }}
          </p>
          <p class="h5n flex col-6 m0" style="justify-content: right;">
            {{ payment.amount }} €
          </p>
        </div>
      </div>
    </div>

    <div v-if="showParticipants || (order.value.helloRoomId && !helloDisabled)" class="m3 p3 white-bg">
      <div v-if="showParticipants">
        <div class="pb2">
          <p class="h3n bold">{{ getReferencelabel(participantsTitleLabel) }}</p>
          <div v-for="(part, partIndex) in order.value.participants" :key="partIndex">
            <p v-if="part" class="h5n">{{ part.firstname }} {{ part.lastname }}</p>
          </div>
        </div>
        <div v-if="order.value.type === 'ucpa'">
          <div v-if="showCommunityParticipantsBlock">
            <p class="h3n bold">{{ baloonsTitleLabel }}</p>
            <div class="flex flex-auto">
              <UserPhoto v-for="photoIndex in 4" :key="photoIndex" class="mr1" style="width: 75px; height: 75px; min-width: 75px; min-height: 75px;" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="order.value.helloRoomId && !helloDisabled" class="flex flex-auto justify-center pt2">
        <Button :reference="discussBtnLabel" class="center my2 col-12 md-col-6 lg-col-6" btn-color="blue" :action="moveToCommunity" />
      </div>
    </div>
  </div>
</template>

<script>

import { onMounted, computed, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import UserPhoto from '@/components/elements/UserPhoto';
import Button from '@/components/elements/Button';
import Document from '@/components/profile/documents/Document';

import { getOrder } from '@/mixins/requests';
import { getReferencelabel, isInImpersonateModeNotification, goToHello } from '@/mixins/utils';

export default {
  components: {
    Button,
    UserPhoto,
    Document
  },
  setup (props, { emit }) {
    const route = useRoute();
    const store = useStore();

    const loaded = ref(false);
    const order = reactive({});

    const participantsTitleLabel = computed(() => {
      if (!order.value.isAdult) {
        return 'WHO_PARTICIPATES';
      }

      return order.value.participants.length === 1 ? 'PARTICIPANT' : 'PARTICIPANTS';
    });

    const baloonsTitleLabel = computed(() => (order.value.isAdult ? 'Qui d’autre part ?' : 'Ils ont inscrit leurs enfants'));

    const discussBtnLabel = computed(() => (order.value.isAdult ? 'JOIN_THE_GROUP' : 'Rejoindre le groupe'));

    const showParticipants = computed(() => {
      if (['Formation', 'Colo'].includes(order.value.market)) {
        return false;
      }
      return order.value.participants && order.value.participants.length;
    });

    const showCommunityParticipantsBlock = computed(() =>
      // Only display community block if ucpa and minor
      order.value.type === 'ucpa' && !order.value.isAdult);

    function goToPaymentSolde (order) {
      // window.open(
      //   `/reservation/paiementsolde?booking=${order.value.bookingNumber}&customer=${order.value.customerId}`,
      //   '_blank'
      // ); // <-- This is how it opens a new tab

      window.open(order.value.payment_info.pay_remaining_link);
    }
    function moveToCommunity () {
      if (isInImpersonateModeNotification()) {
        return;
      }

      if (order.value.helloRoomId) {
        goToHello(order.value.helloRoomId);
      }
    }

    function showPaymentInfo (order) {
      return order.value.payment_info && ((order.value.payment_info.done_payments && order.value.payment_info.done_payments.length) || (order.value.payment_info.future_payments && order.value.payment_info.future_payments.length));
    }

    async function syncOrder () {
      store.commit('setLoading', true);

      emit('orderDetailsLoaded', loaded.value);

      order.value = await getOrder(route.params.uuid);
      loaded.value = true;

      emit('orderDetailsLoaded', loaded.value);

      store.commit('setLoading', false);
    }

    onMounted(async () => {
      await syncOrder();
    });

    const helloDisabled = computed(() => store.getters.getSiteConfiguration('disabled_features').includes('/:locale?/hello'));

    return { order, loaded, participantsTitleLabel, baloonsTitleLabel, discussBtnLabel, goToPaymentSolde, moveToCommunity, showParticipants, showCommunityParticipantsBlock, getReferencelabel, showPaymentInfo, helloDisabled };
  }
};
</script>

<style>
.input-height {
  height: 50px;
}

@media (max-width: 40em) {
  .my-profile-text {
    text-align: center;
  }
}

.bank-details {
  font-family: DINWeb, sans-serif;
  font-size: 0.75rem;
}
</style>
